import { render, staticRenderFns } from "./app.component.html?vue&type=template&id=322acbd1&external"
import script from "./AppComponent.vue?vue&type=script&lang=ts"
export * from "./AppComponent.vue?vue&type=script&lang=ts"
import style0 from "./app.component.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./AppComponent.vue?vue&type=style&index=1&id=322acbd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports